<!---汽车管理-->
<template>
  <div class="manger" v-if="isManager">
    <router-link class="manger-button" :to="`/publish/${_toipic}?id=${$route.params.id}`">
      <i class="yk-detail-edit"></i>
      <span>编辑</span>
    </router-link>

    <button class="manger-button" @click="onDelete">
      <i class="yk-detail-del"></i>
      <span>删除</span>
    </button>

    <template v-if="isManager">
      <button class="manger-button" @click="topVisible = true">
        <i class="yk-detail-top"></i>
        <span>置顶</span>
      </button>

      <button class="manger-button" @click="markVisible = true">
        <i class="yk-detail-highlight"></i>
        <span>醒目</span>
      </button>

      <button class="manger-button" @click="onGoodCancel" v-if="_good == 1">
        <i class="yk-selected"></i>
        <span>取消加精</span>
      </button>

      <button class="manger-button" @click="onGood" v-if="_good != 1">
        <i class="yk-selected"></i>
        <span>加精</span>
      </button>

      <button class="manger-button" @click="onBlackCancel" v-if="_good == 2">
        <i class="yk-blacklist"></i>
        <span>取消拉黑</span>
      </button>

      <button class="manger-button" @click="onBlack" v-if="_good != 2">
        <i class="yk-blacklist"></i>
        <span>拉黑</span>
      </button>

      <button class="manger-button" @click="onKill">
        <i class="yk-detail-banned"></i>
        <span>封杀</span>
      </button>
    </template>

   
    <YorkbbsTopDialog :visible.sync="topVisible" :post="post"></YorkbbsTopDialog>
    <YorkbbsMarkDialog :visible.sync="markVisible" :post="post"></YorkbbsMarkDialog>
  </div>
</template>
<script>

import YorkbbsTopDialog from './dialog-top.vue';
import YorkbbsMarkDialog from './dialog-mark.vue';
export default {
  name: 'CarManger',
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  components: { YorkbbsTopDialog, YorkbbsMarkDialog },
  computed: {
    // 管理员
    isManager() {
      return this.$store.getters.user.identity == 3;
    },
    _good() {
      return this.post.property.good;
    },
    _toipic(){
      return this.post.property.topics[0].englishName;
    }
  },
  data() {
    return {
      // 更换类别对话框
      topicVisible: false,
      // 置顶对话框
      topVisible: false,
      // 醒目对话框
      markVisible: false,

      // 删除状态
      deleteLoading: false,
      // 加精状态
      goodLoading: false,
      // 拉黑状态
      blackLoading: false,
      // 封杀状态
      killLoading: false,
    };
  },
  methods: {
    /**
     * 删除
     */
    async onDelete() {
      const isConfirm = await this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => false);

      if (!isConfirm) return;

      if (this.deleteLoading) return;

      this.deleteLoading = true;
      await this.$axios
        .post('/car/v1/drop/post', {
          postId: [this.$route.params.id],
        })
        .finally(() => {
          this.deleteLoading = false;
        });

      this.$success('删除成功');

      this.$router.replace(`/list/${this._toipic}`);
    },
    /**
     * 加精
     */
    async onGood() {
      if (this.goodLoading) return;

      this.goodLoading = true;
      await this.$axios
        .post('/car/v1/advertising/post', {
          postId: [this.$route.params.id],
          good: 1,
        })
        .finally(() => {
          this.goodLoading = false;
        });

      this.$success('加精成功');
      this.post.property.good = 1;
    },
    /**
     * 取消加精
     */
    async onGoodCancel() {
      if (this.goodLoading) return;

      this.goodLoading = true;
      await this.$axios
        .post('/car/v1/advertising/post', {
          postId: [this.$route.params.id],
          good: 0,
        })
        .finally(() => {
          this.goodLoading = false;
        });

      this.$success('取消加精成功');
      this.post.property.good = 0;
    },
    /**
     * 拉黑
     */
    async onBlack() {
      if (this.blackLoading) return;

      this.blackLoading = true;
      await this.$axios
        .post('/car/v1/advertising/post', {
          postId: [this.$route.params.id],
          good: 2,
        })
        .finally(() => {
          this.blackLoading = false;
        });

      this.$success('拉黑成功');
      this.post.property.good = 2;
    },
    /**
     * 取消拉黑
     */
    async onBlackCancel() {
      if (this.blackLoading) return;

      this.blackLoading = true;
      await this.$axios
        .post('/car/v1/advertising/post', {
          postId: [this.$route.params.id],
          good: 0,
        })
        .finally(() => {
          this.blackLoading = false;
        });

      this.$success('取消拉黑成功');
      this.post.property.good = 0;
    },

    /**
     * 封杀
     */
    async onKill() {
      const isConfirm = await this.$confirm('是否要封杀该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => false);

      if (!isConfirm) return;

      if (this.killLoading) return;

      this.killLoading = true;
      await this.$axios
        .post('/user/v1/update/user/status', {
          userId: this.post.user.id,
          status: 3,
        })
        .finally(() => {
          this.killLoading = false;
        });
      this.$success('封杀成功');
      this.$router.replace(`/list/${this.$route.params.topic}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.manger {
  height: 40px;
  margin-top: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fcebeb;
  color: #e43a3a;
}
.manger-button {
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-right: 40px;
  }
  font-size: 14px;
  i {
    margin-right: 5px;
    font-size: 12px;
  }
}
</style>
